<div class="container-fluid bg-gray-200 pb-5 pt-5 text-primary content">
	<div class="container">
		<div class="row">
			<div class="col-12">
                <div class="bg-white rounded-corners allow-overflow content-inner mb-4 px-5 ">
                    <h1 class="d-flex align-items-center mb-5">
						<span class="bg-green-pacific mr-3 btn-circle-icon"><fa-icon [icon]="['fas', 'sign-in']" class="text-white"></fa-icon></span>
						<span>{{title}}</span>
					</h1>
                    <div class="rounded-corners b-gray-300 mb-4 px-4 py-3 pb-5">
                        <div id="api"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>